// CustomCard.jsx is already correct in expecting item.department.
// No changes are needed here, as the problem is upstream in data mapping.
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

const CustomCard = ({ item }) => {
  const theme = useTheme();
  
  const departmentValue = item.department || "N/A";

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
        borderRadius: "8px",
      }}
    >
      <CardHeader
        title={`Category - ${item.category}`}
        subheader={`Case ID - ${item.caseid}`}
        sx={{
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText,
          borderRadius: "8px",
          padding: 1,
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box sx={{ flex: 1 }}>
          <CardContent
            sx={{
              backgroundColor: theme.palette.background.default,
              borderRadius: "8px",
              padding: 2,
              color: theme.palette.text.primary,
            }}
          >
            <Typography variant="subtitle1" color="text.secondary">
              Priority - {item.priority || "N/A"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Location - {item?.city} {item.location || "N/A"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Date & Time - {item.date}
            </Typography>
            
            {/* Department Display */}
            <Typography variant="body2" color="text.secondary">
              Department - { departmentValue || "N/A"}
            </Typography>
            
            <Typography variant="body2" color="text.secondary">
              Description - {item.description || "N/A"}
            </Typography>
          </CardContent>
        </Box>
        <Box
          sx={{
            position: "relative",
            cursor: "pointer",
            borderRadius: "8px",
            overflow: "hidden",
          }}
          onClick={() => item?.handleMediaClick(item?.allImages)}
        >
          <CardMedia
            component="img"
            sx={{
              width: 150,
              height: 150,
              objectFit: "cover",
              borderRadius: "8px",
              backgroundColor: theme.palette.grey[200],
              marginLeft: 2,
            }}
            image={encodeURI(
              item?.allImages?.[0]?.url || "https://via.placeholder.com/150"
            )}
            alt={`Media for Case ${item.caseid}`}
          />
          {item?.allImages?.length > 0 && (
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "#fff",
                textAlign: "center",
                padding: "4px",
                fontSize: "12px",
              }}
            >
              {item?.allImages?.length} Images
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default CustomCard;